import type { ReactNode } from "react";
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from "next-themes";

type SpareLynkThemeProviderProps = ThemeProviderProps & {
  children: ReactNode;
};

export function ThemeProvider({
  children,
  ...props
}: SpareLynkThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
